// import { Observable } from 'rxjs';

export interface AvailableFunctionParams {
  campus: string,
  year: string,
  uacs: string
}

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class FunctionData {
  // abstract getAvailableFunction(params: AvailableFunctionParams): Observable<ApiResponse>;
}
